import React, { useEffect } from 'react';
import { useGame } from '../context/GameContext';
import GameCanvas from './GameCanvas';
import Chat from './Chat';
import Leaderboard from './Leaderboard';
import MobileControls from './MobileControls';
import CashOut from './CashOut';

const GameArea = () => {
    const { gameStart } = useGame();

    // Debug: Log when gameStart changes and check DOM state
    useEffect(() => {
        console.log('[GameArea] gameStart changed to:', gameStart);
        if (gameStart) {
            // Log the actual DOM state for debugging
            const wrapper = document.getElementById('gameAreaWrapper');
            const canvas = document.getElementById('cvs');
            console.log('[GameArea] Wrapper element:', wrapper);
            console.log('[GameArea] Wrapper className:', wrapper?.className);
            console.log('[GameArea] Wrapper computed style:', wrapper ? window.getComputedStyle(wrapper) : null);
            console.log('[GameArea] Canvas element:', canvas);
            console.log('[GameArea] Canvas dimensions:', canvas?.width, 'x', canvas?.height);
        }
    }, [gameStart]);

    return (
        <div 
            id="gameAreaWrapper" 
            className={gameStart ? 'active' : ''}
            style={{
                // Inline styles as backup to ensure visibility when active
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                opacity: gameStart ? 1 : 0,
                pointerEvents: gameStart ? 'auto' : 'none',
                visibility: gameStart ? 'visible' : 'hidden',
                zIndex: gameStart ? 10 : 1
            }}
        >
            {/* Canvas MUST be first so it's at the bottom of the z-stack */}
            <GameCanvas />
            <Leaderboard />
            <Chat />
            <MobileControls />
            <CashOut />
        </div>
    );
};

export default GameArea;


